export const SHADOW_CSS_TEXT = `
/* ============================================
   GLOBAL RESET INSIDE SHADOW DOM
============================================ */
.html-wrapper * {
  position: relative !important; 
  transform: none !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  bottom: auto !important;
  max-width: 100% !important;
  overflow: visible !important;
  box-sizing: border-box;
}

.html-wrapper {
  font-family: Inter, sans-serif;
  font-size: 15px;
  line-height: 1.75;
  color: #1e293b;
  background: #ffffff;
  padding: 28px 30px;
  border-radius: 14px;
  overflow: hidden;
}

/* ============================================
   HEADINGS (Aesthetic, Slightly Smaller)
============================================ */
.html-wrapper h1,
.html-wrapper h2,
.html-wrapper h3,
.html-wrapper h4,
.html-wrapper h5,
.html-wrapper h6 {
  font-weight: 650;
  color: #0f172a;
  margin: 26px 0 12px;
  line-height: 1.35;
  letter-spacing: -0.01em;
}

.html-wrapper h1 { font-size: 24px; margin-top: 38px; }
.html-wrapper h2 { font-size: 21px; }
.html-wrapper h3 { font-size: 18px; }
.html-wrapper h4 { font-size: 16px; }
.html-wrapper h5 { font-size: 15px; }
.html-wrapper h6 { font-size: 14px; color: #374151; }

/* Subheading paragraph */
.html-wrapper .subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: -6px;
}

/* ============================================
   PARAGRAPHS
============================================ */
.html-wrapper p {
  margin: 14px 0 20px;
  color: #334155;
  line-height: 1.75;
}

/* ============================================
   LINKS
============================================ */
.html-wrapper a {
  color: #3b82f6;
  text-decoration: underline;
  font-weight: 500;
}
.html-wrapper a:hover {
  color: #2563eb;
}

/* ============================================
   LISTS
============================================ */
.html-wrapper ul,
.html-wrapper ol {
  margin: 12px 0 18px 24px;
  padding-left: 14px;
}

.html-wrapper li {
  margin: 5px 0;
  color: #1e293b;
}

/* ============================================
   BLOCKQUOTES (Soft Notion Style)
============================================ */
.html-wrapper blockquote {
  border-left: 3px solid #6366f1;
  padding: 14px 18px;
  margin: 24px 0;
  background: #f5f6ff;
  border-radius: 10px;
  color: #475569;
  font-style: italic;
}

/* ============================================
   HR
============================================ */
.html-wrapper hr {
  margin: 26px 0;
  border: none;
  border-top: 1px solid #e5e7eb;
}

/* ============================================
   IMAGES
============================================ */
.html-wrapper img {
  max-width: 100%;
  display: block;
  margin: 22px auto;
  border-radius: 12px;
}

/* ============================================
   TABLE (Calm, Soft, Premium)
============================================ */
.html-wrapper table {
  width: 100%;
  border-collapse: collapse;
  margin: 24px 0;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  font-size: 15px;
  box-shadow: 0 0 0 1px #e5e7eb;
}

.html-wrapper th {
  background: #f8fafc;
  font-weight: 600;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  color: #1e293b;
}

.html-wrapper td {
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.html-wrapper tr:nth-child(even) {
  background: #fafafa;
}

/* ============================================
   CODE BLOCKS
============================================ */
.html-wrapper pre {
  background: #1e1e2f;
  color: #eaeaea;
  padding: 18px;
  border-radius: 12px;
  overflow-x: auto;
  font-size: 14px;
  margin: 26px 0;
}

.html-wrapper code {
  font-family: "SFMono-Regular", Consolas, monospace;
  background: #e2e8f0;
  padding: 3px 6px;
  border-radius: 5px;
  color: #1e293b;
}

.html-wrapper pre code {
  background: transparent;
  padding: 0;
  color: inherit;
}

/* ============================================
   IFRAME
============================================ */
.html-wrapper iframe {
  width: 100%;
  border: none;
  border-radius: 12px;
  margin: 24px 0;
}

/* ============================================
   FIGURES
============================================ */
.html-wrapper figure {
  margin: 28px 0;
  text-align: center;
}

.html-wrapper figcaption {
  margin-top: 8px;
  font-size: 14px;
  color: #64748b;
}

/* ============================================
   DETAILS / SUMMARY
============================================ */
.html-wrapper details {
  margin: 20px 0;
  padding: 14px 16px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
}

.html-wrapper summary {
  font-weight: 600;
  color: #1e293b;
}

/* ============================================
   FORM ELEMENTS
============================================ */
.html-wrapper input,
.html-wrapper textarea,
.html-wrapper select {
  width: 100%;
  padding: 10px 14px;
  margin: 10px 0;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  font-size: 15px;
  background: #ffffff;
}

.html-wrapper button {
  padding: 10px 16px;
  background: #4f46e5;
  border: none;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  margin-top: 10px;
  font-size: 15px;
  font-weight: 600;
}

.html-wrapper button:hover {
  background: #4338ca;
}

/* ============================================
   SMALL TEXT
============================================ */
.html-wrapper sup,
.html-wrapper sub {
  font-size: 0.75em;
}

.html-wrapper address {
  font-style: italic;
  color: #475569;
  margin: 10px 0;
}
`;
